<div class="text-center" *ngIf="!promocionesCargadas">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div class="row" *ngIf="promocionesCargadas">
  <div class="col-lg-6" *ngIf="separated || cash">
    <div class="row">
      <div class="col-lg-12">
        <!-- Un banner por grupo y debajo sus artículos: contado y apartado, primero con promoción -->
        <ng-container *ngFor="let grupo of gruposContadoApartado">
        <div class="mb-2" *ngIf="grupo.imagen">
          <img [src]="grupo.imagen" class="card-img-top" [alt]="grupo.alt" />
        </div>

        <div class="card-wrapper" *ngFor="let item of grupo.items">
          <div
            class="card h-100 border-card-contado"
            *ngIf="item.saleTypeId == 2"
          >
            <div class="text-center parent-img" style="min-height: 180px">
              <img
                class="card-img-top card-img-item img-fluid"
                src="https://www.soporteroga.com/Images_ROGA/{{ item.image }} "
                alt="Card image cap "
                (error)="onImgError($event)"
              />

              <!-- Logo de promoción sobre productos de contado que entran en la promoción -->
              <img
                *ngIf="itemHasPromotion(item) && promotionImages.getPromotionLogo(promotionName)"
                [src]="promotionImages.getPromotionLogo(promotionName)"
                alt="Logo {{ promotionName }}"
                class="child-img-bf"
              />

              <!-- QR de promoción arriba a la derecha (esquemas 28 y 39) - Solo Buen Fin -->
              <img
                *ngIf="
                  (item.purchasePlanId === 28 || item.purchasePlanId === 39) &&
                  itemHasPromotion(item) &&
                  isBuenFin
                "
                [src]="getPromotionQr(item)"
                alt="QR {{ promotionName }}"
                class="child-img-qr"
              />

              <!-- Badge de 5% descuento (específico para esquema 28) -->
              <img
                *ngIf="item.purchasePlanId === 28 && itemHasPromotion(item)"
                src="/assets/bf/5_por.png"
                alt="5% descuento"
                class="child-img-5"
              />

              <!-- Clock icon abajo a la izquierda (esquemas 28 y 39) -->
              <img
                *ngIf="
                  (item.purchasePlanId === 28 || item.purchasePlanId === 39) &&
                  itemHasPromotion(item) &&
                  isBuenFin
                "
                src="/assets/bf/clock.png"
                alt="Clock {{ promotionName }}"
                class="child-img-clock"
              />
            </div>

            <div class="card-body contado">
              <h5 class="card-title b-text card-title-text">
                {{ item.sku }} - {{ item.line }}
              </h5>
              <h5
                class="card-title b-text card-title-text"
                *ngIf="item.quantity > 1"
              >
                # Articulos {{ item.quantity }}
              </h5>
              <div class="card-text">
                <span class="purchase-plan-text">{{
                  fixOrtography(item.purchasePlan)
                }}</span
                ><br />
                <div *ngIf="item.prices[0].luFactor > 0">
                  <span
                    >Págo único de
                    {{
                      (item.prices[0].salePrice * item.prices[0].luFactor +
                        item.prices[0].installationPrice) *
                        item.quantity | currency : "USD" : "symbol" : "1.0-0"
                    }}</span
                  ><br />
                </div>

                <div *ngIf="item.prices[0].luFactor === 0">
                  <span
                    >Págo único de
                    {{
                      roundNumber(
                        (item.prices[0].salePrice +
                          item.prices[0].installationPrice) *
                          item.quantity
                      ) | currency : "USD" : "symbol" : "1.0-0"
                    }}</span
                  ><br />
                </div>
                <span *ngIf="item.purchasePlanId == 2"
                  >¡Congela con
                  {{ 50 | currency : "USD" : "symbol" : "1.0-0" }} pesos el
                  precio de tu artículo a 16 semanas!</span
                >

                <span *ngIf="item.purchasePlanId == 39 && itemHasPromotion(item)">
                  ¡Congela con
                  {{ 50 | currency : "USD" : "symbol" : "1.0-0" }} pesos el
                  precio de tu artículo para liquidar hasta el 31 de Enero del
                  2027!</span
                >

                <span
                  *ngIf="
                    item.purchasePlanId != 2 &&
                    !(item.purchasePlanId == 39 && itemHasPromotion(item))
                  "
                >
                  ¡Congela con
                  {{ 50 | currency : "USD" : "symbol" : "1.0-0" }} pesos el
                  precio de tu artículo a 20 semanas!</span
                >
              </div>
              <ul class="price-list">
                <li>
                  <span *ngIf="item.lu || item.luType > 0" class="subtext"
                    >* Este producto tiene descuento especial dependiendo las
                    condiciones del artículo.</span
                  >
                </li>
                <li>
                  <span *ngIf="isMotocicleta(item)" class="subtext"
                    >* Recuerda que debes proporcionar tus datos fiscales
                    durante tu compra para generar tu factura fiscal.</span
                  >
                </li>

                <!-- <li> <span *ngIf="item.purchasePlanId===28 || item.purchasePlanId===39 "
                                        class="subtext">* Promoción 30 Aniversario, Valido por el mes de
                                        {{restService.mes}} 2022.</span>
                                </li> -->
                <li>
                  <span
                    *ngIf="item.prices[0].installationPrice > 0"
                    class="subtext"
                    >* Incluye instalación</span
                  >
                </li>
                <li>
                  <span
                    *ngIf="
                      (item.purchasePlanId == 28 ||
                        item.purchasePlanId == 39) &&
                      itemHasPromotion(item)
                    "
                    class="subtext"
                  >
                    {{ promotionLegend }}</span
                  >
                </li>
              </ul>
            </div>
            <button
              *ngIf="item.video != 'NA'"
              type="button"
              class="btn btn-light"
              (click)="onClickOpenVideo(item.video)"
            >
              ¡Ver vídeo del producto!
            </button>
          </div>

          <div
            class="card h-100 border-card-apartado"
            *ngIf="item.saleTypeId == 6"
          >
            <div class="text-center parent-img" style="min-height: 180px">
              <img
                class="card-img-top card-img-item img-fluid"
                src="http://www.soporteroga.com/Images_ROGA/{{ item.image }} "
                alt="Card image cap "
                (error)="onImgError($event)"
              />

              <!-- Logo de promoción sobre productos de apartado que entran en la promoción -->
              <img
                *ngIf="itemHasPromotion(item) && promotionImages.getPromotionLogo(promotionName)"
                [src]="promotionImages.getPromotionLogo(promotionName)"
                alt="Logo {{ promotionName }}"
                class="child-img-bf"
              />

              <!-- QR de promoción arriba a la derecha (esquema 29) - Solo Buen Fin -->
              <img
                *ngIf="
                  item.purchasePlanId === 29 &&
                  itemHasPromotion(item) &&
                  isBuenFin
                "
                [src]="getPromotionQr(item)"
                alt="QR {{ promotionName }}"
                class="child-img-qr"
              />
            </div>
            <div class="card-body apartado">
              <h5 class="card-title b-text card-title-text">
                {{ item.sku }} - {{ item.line }}
              </h5>
              <h5
                class="card-title b-text card-title-text"
                *ngIf="item.quantity > 1"
              >
                # Articulos {{ item.quantity }}
              </h5>

              <div class="card-text">
                <span class="purchase-plan-text">{{
                  fixOrtography(item.purchasePlan)
                }}</span
                ><br />
                <ul
                  class="price-list"
                  *ngFor="let price of item.prices; index as i"
                >
                  <div *ngIf="price.luFactor > 0">
                    <!-- <li *ngIf="item.prices.indexOf(price)<1 ">Precio {{ price.purchasePlan }}: {{
                                            (((price.salePrice*price.luFactor) +price.installationPrice)
                                            *price.quantity)| currency}}</li> -->
                    <li>
                      Precio
                      {{
                        roundNumber(
                          (price.salePrice * price.luFactor +
                            price.installationPrice) *
                            price.quantity
                        ) | currency : "USD" : "symbol" : "1.0-0"
                      }}
                      Apártalo a {{ price.term * 2 }} Pagos Semanales de
                      {{
                        roundNumber(
                          ((price.salePrice + price.installationPrice) *
                            price.quantity -
                            price.deposit) /
                            (price.term * 2)
                        ) | currency : "USD" : "symbol" : "1.0-0"
                      }}, Ahorras
                      {{
                        roundNumber(calculateSavings(item, price))
                          | currency : "USD" : "symbol" : "1.0-0"
                      }}
                    </li>
                  </div>

                  <div *ngIf="price.luFactor === 0">
                    <ul *ngIf="calculateSavings(item, price) <= 0">
                      <li>
                        Precio
                        {{
                          roundNumber(
                            (price.salePrice + price.installationPrice) *
                              price.quantity
                          ) | currency : "USD" : "symbol" : "1.0-0"
                        }}
                        Apártalo a {{ price.term * 2 }} Pagos Semanales de
                        {{
                          roundNumber(
                            ((price.salePrice + price.installationPrice) *
                              price.quantity -
                              price.deposit) /
                              (price.term * 2)
                          ) | currency : "USD" : "symbol" : "1.0-0"
                        }}
                      </li>
                    </ul>
                    <ul *ngIf="calculateSavings(item, price) > 0">
                      <li>
                        Precio
                        {{
                          roundNumber(
                            (price.salePrice + price.installationPrice) *
                              price.quantity
                          ) | currency : "USD" : "symbol" : "1.0-0"
                        }}
                        Apártalo a
                        {{ price.term * 2 }}
                        Pagos Semanales de
                        {{
                          roundNumber(
                            ((price.salePrice + price.installationPrice) *
                              price.quantity -
                              price.deposit) /
                              (price.term * 2)
                          ) | currency : "USD" : "symbol" : "1.0-0"
                        }}, Ahorras
                        {{
                          roundNumber(calculateSavings(item, price))
                            | currency : "USD" : "symbol" : "1.0-0"
                        }}
                      </li>
                    </ul>
                  </div>
                </ul>
                <ul class="price-list">
                  <li>
                    <span *ngIf="item.lu || item.luType > 0" class="subtext"
                      >* Este producto tiene descuento especial dependiendo las
                      condiciones del artículo.
                    </span>
                  </li>
                  <li>
                    <span *ngIf="isMotocicleta(item)" class="subtext"
                      >* Recuerda que debes proporcionar tus datos fiscales
                      durante tu compra para generar tu factura fiscal.</span
                    >
                  </li>
                  <li>
                    <span
                      *ngIf="item.purchasePlanId === 29 && itemHasPromotion(item)"
                      class="subtext"
                      >* {{ promotionLegend }}</span
                    >
                  </li>
                  <li>
                    <span
                      *ngIf="item.prices[0].installationPrice > 0"
                      class="subtext"
                      >* Incluye instalación</span
                    >
                  </li>
                </ul>
              </div>
            </div>
            <button
              *ngIf="item.video != 'NA'"
              type="button"
              class="btn btn-light"
              (click)="onClickOpenVideo(item.video)"
            >
              ¡Ver vídeo del producto!
            </button>
          </div>
        </div>
        </ng-container>
      </div>

      <div class="col-lg-12 my-3">
        <!-- Banner de envíos - Gestión dinámica por promoción -->
        <img
          [src]="getPromotionImage('envios', sectionHasPromotion(2, 6))"
          class="card-img-top"
          alt="Banner de envíos"
        />
      </div>
    </div>
  </div>
  <div class="col-lg-6" *ngIf="credit">
    <div class="row h-100">
      <div class="col-lg-12">
        <!-- Un banner por grupo (motos o crédito) y debajo sus artículos -->
        <ng-container *ngFor="let grupo of gruposCredito">
        <div class="mb-2">
          <img [src]="grupo.imagen" class="card-img-top" [alt]="grupo.alt" />
        </div>

        <div class="card-wrapper" *ngFor="let item of grupo.items">
          <!-- CREDITO = 4 -->
          <div
            class="card h-100 border-card-credito"
            *ngIf="item.saleTypeId == 4"
          >
            <div class="text-center parent-img" style="min-height: 180px">
              <img
                class="card-img-top card-img-item img-fluid"
                src="http://www.soporteroga.com/Images_ROGA/{{ item.image }}"
                alt="Card image cap"
                (error)="onImgError($event)"
              />

              <!-- Logo de promoción sobre productos de crédito que entran en la promoción -->
              <img
                *ngIf="itemHasPromotion(item) && promotionImages.getPromotionLogo(promotionName)"
                [src]="promotionImages.getPromotionLogo(promotionName)"
                alt="Logo {{ promotionName }}"
                class="child-img-bf"
              />

              <!-- QR de promoción arriba a la derecha (todos los créditos) - Solo Buen Fin -->
              <img
                *ngIf="itemHasPromotion(item) && isBuenFin"
                [src]="getPromotionQr(item)"
                alt="QR {{ promotionName }}"
                class="child-img-qr"
              />
            </div>
            <div class="card-body credito">
              <div class="">
                <h5 class="card-title b-text card-title-text">
                  {{ item.sku }} - {{ item.line }}
                </h5>
                <h5
                  class="card-title b-text card-title-text"
                  *ngIf="item.quantity > 1"
                >
                  # Articulos {{ item.quantity }}
                </h5>
              </div>
              <div class="card-text">
                <span class="purchase-plan-text"
                  >{{ fixOrtography(item.purchasePlan) }} </span
                ><br />
                <ul class="price-list" *ngFor="let price of item.prices">
                  <div *ngIf="price.luFactor > 0">
                    <li *ngIf="item.prices[0].salePrice - price.salePrice == 0">
                      {{ price.term * 2 }} Pagos Semanales de
                      {{
                        roundNumber(
                          ((price.salePrice * price.luFactor +
                            price.installationPrice) *
                            price.quantity -
                            price.deposit) /
                            (price.term * 2)
                        ) | currency : "USD" : "symbol" : "1.0-0"
                      }}
                    </li>

                    <li *ngIf="calculateSavings(item, price) > 0">
                      {{ price.term * 2 }} Pagos Semanales de
                      {{
                        roundNumber(
                          ((price.salePrice * price.luFactor +
                            price.installationPrice) *
                            price.quantity -
                            price.deposit) /
                            (price.term * 2)
                        ) | currency : "USD" : "symbol" : "1.0-0"
                      }}, Ahorras
                      {{
                        roundNumber(calculateSavings(item, price))
                          | currency : "USD" : "symbol" : "1.0-0"
                      }}
                    </li>
                  </div>
                  <div *ngIf="price.luFactor === 0">
                    <li *ngIf="calculateSavings(item, price) == 0">
                      {{ price.term * 2 }} Pagos Semanales de
                      {{
                        roundNumber(
                          ((price.salePrice + price.installationPrice) *
                            price.quantity -
                            price.deposit) /
                            (price.term * 2)
                        ) | currency : "USD" : "symbol" : "1.0-0"
                      }}
                    </li>

                    <li *ngIf="calculateSavings(item, price) > 0">
                      {{ price.term * 2 }} Pagos Semanales de
                      {{
                        roundNumber(
                          ((price.salePrice + price.installationPrice) *
                            price.quantity -
                            price.deposit) /
                            (price.term * 2)
                        ) | currency : "USD" : "symbol" : "1.0-0"
                      }}, Ahorras
                      {{
                        roundNumber(calculateSavings(item, price))
                          | currency : "USD" : "symbol" : "1.0-0"
                      }}
                    </li>
                  </div>
                </ul>
                <ul class="price-list">
                  <li>
                    <span class="subtext"
                      >* Pagos semanales calculados con
                      {{
                        item.prices[0].deposit
                          | currency : "USD" : "symbol" : "1.0-0"
                      }}
                      pesos de enganche.</span
                    >
                  </li>
                  <li>
                    <span *ngIf="item.lu || item.luType > 0" class="subtext"
                      >* Este producto tiene descuento especial dependiendo las
                      condiciones del artículo.</span
                    >
                  </li>
                  <li>
                    <span *ngIf="isMotocicleta(item)" class="subtext"
                      >* Recuerda que debes proporcionar tus datos fiscales
                      durante tu compra para generar tu factura fiscal.</span
                    >
                  </li>
                  <li>
                    <span
                      *ngIf="itemHasPromotion(item)"
                      class="subtext"
                    >
                      {{ promotionLegend }}</span
                    >
                  </li>
                  <li>
                    <span
                      *ngIf="item.prices[0].installationPrice > 0"
                      class="subtext"
                      >* Incluye instalación</span
                    >
                  </li>
                </ul>
              </div>
            </div>
            <button
              *ngIf="item.video != 'NA'"
              type="button"
              class="btn btn-light"
              (click)="onClickOpenVideo(item.video)"
            >
              ¡Ver vídeo del producto!
            </button>
          </div>
        </div>
        </ng-container>
      <div class="col-lg-12 align-self-end my-3">
        <div>
          <img
            [src]="getPromotionImage('footerCredit', sectionHasPromotion(4))"
            class="card-img-top"
            alt="Banner pie de crédito{{ sectionHasPromotion(4) ? ' - ' + promotionName : '' }}"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<app-video-modal
  *ngIf="openVideo"
  [ytSrc]="videoSleccionado"
  (closeModal)="onCloseVideo($event)"
></app-video-modal>
